import React, { Component } from 'react';
import TimeUtils from '../../utils/TimeUtils';
import ClosedQuestion from "./ClosedQuestion";
import OpenQuestion from "./OpenQuestion";
import GapQuestion from "./GapQuestion";

import './css/Test.css';
import Header from "./Header";
import SelectQuestion from "./SelectQuestion";
import API from "../../api/API";

class Test extends Component {
    constructor(props) {
        super(props);

        this.state = {
            startTimestamp: 0,
            time: 0,
            questions: [],
            answers: []
        };

        this.answers = this.state.answers;
    }

    componentDidMount() {
        API.callAPI('tests/?id=' + this.props.id)
            .then(response => {
                if (response['error']) {
                    return;
                }

                const started_at = response.started_at;

                this.setState({
                    startTimestamp: started_at,
                    time: response.time,
                    timeLeft: response.time * 60,
                    questions: JSON.parse(response.test)
                }, () => {
                    const timeUpdateInterval = setInterval(() => {
                        const timeDifference = TimeUtils.getTimestamp() - this.state.startTimestamp;
                        let timeLeft = this.state.time * 60 - timeDifference;
                        if (timeLeft < 0) {
                            timeLeft = 0;
                            this.saveAndReturn();
                            this.componentWillUnmount();
                        }
                        this.setState({ timeLeft: parseInt(timeLeft) });
                    }, 1000);

                    const saveTimeInterval = setInterval(() => {
                        this.save();
                    }, 60000);

                    const testActivityCheckInterval = setInterval(() => {
                        API.callAPI('tests/?id=' + this.props.id).then((response) => {
                            if (response.error && response.error === 404) {
                                this.saveAndReturn();
                            }
                        })
                    }, 5000);

                    this.setState({
                        timeUpdateInterval: timeUpdateInterval,
                        saveTimeInterval: saveTimeInterval,
                        testActivityCheckInterval: testActivityCheckInterval
                    });
                });
            });

    }

    componentWillUnmount() {
        clearInterval(this.state.timeUpdateInterval);
        clearInterval(this.state.saveTimeInterval);
        clearInterval(this.state.testActivityCheckInterval);
    }

    saveAnswer = (question, answer) => {
        const answers = this.answers;
        answers[question] = answer;
        this.setState({ answers: answers });
        console.log(answers);
    };

    saveAndReturn = () => {
        API.callAPI('tests/return/', 'POST', {
            "id": this.props.id,
            "answers": this.answers
        }).then(response => {
            if (response['error']) {
                return;
            }

            this.props.openList();
        });
    };

    save = () => {
        API.callAPI('tests/return/', 'PUT', {
            "id": this.props.id,
            "answers": this.answers
        });
    };

    render() {
        const timeLeft = this.state.timeLeft;
        let i = 0;
        let number = 1;
        let questions = <div className="loader-wrapper"><div className="loader" /></div>;
        if (this.state.questions) {
            questions = this.state.questions.map(question => {
                const task = this.createTask(question, i, number);
                i += 1;
                if (question['type'] !== 'header') number += 1;
                return task;
            });
        }
        return (
            <div className="test">
                <div className="toolbar">
                    <div className="toolbar-content">
                        <div className="time">Pozostały czas: <span className={"time-left " + (timeLeft < 10 * 60 ? "time-left-red" : "")}>{TimeUtils.format(timeLeft)}</span></div>
                        <div className=""><button className="btn-square" onClick={this.saveAndReturn}>Oddaj test</button></div>
                    </div>
                </div>
                <div className="">
                    {questions}
                </div>
            </div>
        )
    }

    createTask(question, id, number) {
        let questionKey = "question-" + question.uniqueId;
        const questionNumber = number;

        if (question['type'] === "closed") {
            return (
                <ClosedQuestion
                    key={questionKey}
                    id={id}
                    questionNumber={questionNumber}
                    question={question.question}
                    answers={question.answers}
                    multipleChoice={question.multipleChoice}
                    shuffle={question.shuffle}
                    saveAnswer={this.saveAnswer}
                />)
        }

        if (question['type'] === "open") {
            return (
                <OpenQuestion
                    key={questionKey}
                    id={id}
                    questionNumber={questionNumber}
                    question={question.question}
                    multiline={question.multiline}
                    shuffle={question.shuffle}
                    saveAnswer={this.saveAnswer}
                />)
        }

        if (question['type'] === "gap") {
            return (
                <GapQuestion
                    key={questionKey}
                    id={id}
                    questionNumber={questionNumber}
                    question={question.question}
                    subtasks={question.subtasks}
                    saveAnswer={this.saveAnswer}
                />
            );
        }

        if (question['type'] === "select") {
            return (
                <SelectQuestion
                    key={questionKey}
                    id={id}
                    questionNumber={questionNumber}
                    question={question.question}
                    subtasks={question.subtasks}
                    options={question.options}
                    shuffle={question.shuffle}
                    saveAnswer={this.saveAnswer}
                />
            )
        }

        if (question['type'] === "header") {
            questionKey = "header-after-" + questionNumber;
            return (
                <Header
                    id={id}
                    key={questionKey}
                    header={question.header}
                    description={question.description}
                />
            );
        }
    }
}

export default Test;